import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getHourTypes = () => {
    return request({
        url: namespace + "/hourtypes",
        method: "get",
    });
};

export const getHourType = (ht_id) => {
    return request({
        url: namespace + "/hourtype/" + ht_id,
        method: "get",
    });
};

export const createHourType = (payload) => {
    return request({
        url: namespace + "/hourtype",
        data: payload,
        method: "post",
    });
};

export const updateHourType = (ht_id, payload) => {
    return request({
        url: namespace + "/hourtype/" + ht_id,
        data: payload,
        method: "put",
    });
};

export const destroyHourType = (ht_id) => {
    return request({
        url: namespace + "/hourtype/" + ht_id,
        method: "delete",
    });
};